import React, {useState, useMemo, useRef, useEffect, useCallback} from "react";
import {SketchPicker} from "react-color";
import EmojiPicker, {
    EmojiStyle,
    SkinTones,
    Theme,
    Categories,
    EmojiClickData,
    Emoji,
    SuggestionMode,
    SkinTonePickerLocation
} from "emoji-picker-react";
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import '../../../css/modules/text-editor.css';
import $ from "jquery";
import SelectBox from "../common/SelectBox";
import textEditorIcon from './textEditorIcon';
import textEditorFont from "./textEditorFont";
import {tagName} from "./textEditorUtils";
import {textEditorFontSize} from "./textEditorUtils";
import {textEditorLetterSpacing} from "./textEditorUtils";
import {textEditorLineHeight} from "./textEditorUtils";
import axios from "axios";
import * as StyleUtil from "../utils/StyleUtil";
import InputDialogV2 from "../dialogs/InputDialogV2";
import SelectBoxV2 from '../common/SelectBoxV2';
import {rgbToHex} from "@mui/material";


// 블록 정보 초기화를 위한 변수
let preClass = "";
let curClass = "";
let windowScrollTop;

const Icon = ({editor, icon, tag, tagName}) => {
    return (
        <div className={"icon_text_editor " + tagName} onClick={(e) => {wrapTag(e, editor, tag, tagName)}} onMouseDown={(e) => e.preventDefault()}>
            {icon}
        </div>
    );
}

const wrapTag = (e, editor, tag, tagName) => {
    document.designMode = "off"

    if(checkSelection()){
        return;
    }
    if(document.getSelection().anchorNode.parentElement.closest("." + editor)){
        switch (tagName) {
            case 'removeFormat':
                document.execCommand('removeFormat', false, null);
                document.execCommand('backColor', false, "initial");

                // 셀렉트박스 초기화
                // document.querySelectorAll('.select_box_text_editor').forEach((element) => {
                //     element.value = "";
                // });
                document.querySelectorAll('.txt_font_family_text_editor').forEach((element) => {
                    element.innerHTML = "글씨체";
                });
                // document.querySelectorAll('.txt_font_size_text_editor').forEach((element) => {
                //     element.innerHTML = "글씨 크기";
                // });
                break;
            case 'p':
                document.execCommand('formatBlock', false, tagName);
                break;
            default:
                document.execCommand(tagName, false, null);
                break;
        }
    }
}

const checkSelection = () =>{
    if(document.getSelection().anchorNode == null){
        return true;
    }
    if(document.getSelection().anchorNode.parentElement == null){
        return true;
    }
    if(document.getSelection().anchorNode.parentElement.closest(".text_editor_title") == null){
        return true;
    }
}

export const TextEditor = ({id, contentEditableId, onBannerTemplateChange, onMobileBannerTemplateChange, checkImgLinkUseAble, isHorizontal, w_large_text_color, h_large_text_color, w_small_text_color, h_small_text_color, language_code_list, language_code, handleLanguageChange}) => {
    const [selectedRange, setSelectedRange] = useState(null);
    const [fontFamilyIsOpen, setFontFamilyIsOpen] = useState(false);
    const [fontSizeIsOpen, setFontSizeIsOpen] = useState(false);
    const [fontColor, setFontColor] = useState("");
    const [fontBackColor, setFontBackColor] = useState("");
    const [fontColorSketchPickerIsOpen, setFontColorSketchPickerIsOpen] = useState(false);
    const [fontBackColorSketchPickerIsOpen, setFontBackColorSketchPickerIsOpen] = useState(false);
    const [emojiPickerIsOpen, setEmojiPickerIsOpen] = useState(false);
    const [translatePickerIsOpen, setTranslatePickerIsOpen] = useState(false);
    const [paletteBackIsOpen, setPaletteBackIsOpen] = useState(false);
    const [imgAttachIsOpen, setImgAttachIsOpen] = useState(false);
    const [imgUrlDialogIsOpen, setImgUrlDialogIsOpen] = useState(false);

    const inputRef = useRef(null);

    useMemo(() => {
        // console.log("123");
    }, [])

    const useComponentWillMount = (func) => {
        const willMount = useRef(true);
        if (willMount.current) func();
        willMount.current = false;
    }

    useComponentWillMount(() => {
        // console.log("456");
    });

    useEffect(() => {
        // 텍스트 문구 입력창 blur 이벤트시 selection 유지
        document.querySelector("." + id).onblur = (e) => {
            e.stopPropagation();

            // selection 정보 저장
            saveSelection();
        };

        // 컬러 초기화
        document.querySelector("#" + id + " .removeFormat").onclick = ((e) => {
            setFontColor("");
            setFontBackColor("");
        });

        // 드래그 영역 감지 후 에디터 설정 변경
        document.onmouseup = (e) => {
            try {
                if(document.getSelection().type === 'Range') {
                    let editor = "";

                    if (document.getSelection().anchorNode.parentElement.closest(".subTextEditor")) {
                        editor = "subTextEditor";
                    }else {
                        editor = "mainTextEditor"
                    }

                    let fontFace;
                    let fontSize;
                    let fontColor;
                    let fontBackColor;

                    // 글씨체
                    if(document.getSelection().anchorNode.parentElement.face){
                        fontFace = document.getSelection().anchorNode.parentElement.face;
                    }else if(document.getSelection().anchorNode.parentElement.parentElement.face){
                        fontFace = document.getSelection().anchorNode.parentElement.parentElement.face;
                    }else if(document.getSelection().anchorNode.parentElement.parentElement.parentElement.face){
                        fontFace = document.getSelection().anchorNode.parentElement.parentElement.parentElement.face;
                    }else if(document.getSelection().anchorNode.parentElement.closest("span") != null){
                        fontFace = document.getSelection().anchorNode.parentElement.closest("span").style.fontFamily;
                    }

                    // 글씨 색상
                    if(document.getSelection().anchorNode.parentElement.color){
                        fontColor = document.getSelection().anchorNode.parentElement.color;
                    }else if(document.getSelection().anchorNode.parentElement.parentElement.color){
                        fontColor = document.getSelection().anchorNode.parentElement.parentElement.color;
                    }else if(document.getSelection().anchorNode.parentElement.parentElement.parentElement.color){
                        fontColor = document.getSelection().anchorNode.parentElement.parentElement.parentElement.color;
                    }else if(document.getSelection().anchorNode.parentElement.closest("span") != null){
                        fontColor = document.getSelection().anchorNode.parentElement.closest("span").style.color;
                    }

                    // 글씨 배경 색상
                    if(document.getSelection().anchorNode.parentElement.style.backgroundColor) {
                        fontBackColor = document.getSelection().anchorNode.parentElement.style.backgroundColor;
                    }else if(document.getSelection().anchorNode.parentElement.closest("span") != null){
                        fontBackColor = document.getSelection().anchorNode.parentElement.closest("span").style.backgroundColor;
                    }else if(document.getSelection().anchorNode.parentElement.closest("font") != null) {
                        fontBackColor = document.getSelection().anchorNode.parentElement.closest("font").style.backgroundColor;
                    }

                    // let fontSizeValue = String((Number(fontSize) * 0.2 + 0.6).toFixed(1));
                    //
                    // if(fontSizeValue == "1.0") {
                    //     fontSizeValue = "1";
                    // }else if(fontSizeValue == "2.0") {
                    //     fontSizeValue = "2";
                    // }

                    if(fontFace != null && fontFace != "") {
                        // document.querySelector("#" + editor + " .select_box_font_family").value = fontFace;
                        document.querySelector("#" + editor +" .txt_font_family_text_editor").innerHTML = fontFace;
                    }
                    // if(fontSize != null && fontSize != "") {
                    //     document.querySelector("#" + editor + " .select_box_font_size").value = fontSizeValue;
                    //     document.querySelector("#" + editor +" .txt_font_size_text_editor").innerHTML = fontSizeValue + "x";
                    // }
                    if(fontColor != null && fontColor != "") {
                        document.querySelector("#" + editor + " .input_font_color_text_editor").value = rgbToHex(fontColor);
                        document.querySelector("#" + editor + " .box_font_color_text_editor").style.backgroundColor = rgbToHex(fontColor);
                    }
                    if(fontBackColor != null && fontBackColor != "") {
                        document.querySelector("#" + editor + " .input_font_back_color_text_editor").value = rgbToHex(fontBackColor);
                        document.querySelector("#" + editor + " .box_font_back_color_text_editor").style.backgroundColor = rgbToHex(fontBackColor);
                    }
                }
            }catch (e) {
                console.log(e)
            }
        };

        const handleOutsideClick = (e) => {
            // 1. 클릭된 요소가 각 에디터 영역(Wrapper) 내부에 있는지 확인
            const isEmojiClick = e.target.closest("em-emoji-picker");
            const isEmojiClick2 = e.target.closest(".wrap_emoji_text_editor");
            const isTranslateClick = e.target.closest(".wrap_translate_text_editor");
            const isImgAttachClick = e.target.closest(".img_text_editor");

            // 2. 만약 클릭된 곳이 위 영역들 중 어느 곳도 아니라면 (즉, 완전한 외부라면) 닫기
            if (!isEmojiClick && !isEmojiClick2) {
                setEmojiPickerIsOpen(false);
            }
            if (!isTranslateClick) {
                setTranslatePickerIsOpen(false);
            }
            if (!isImgAttachClick) {
                setImgAttachIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);

    }, []);

    // 템플릿/샘플 컬러 변경시 초기화
    useEffect(() => {
        setFontColor("");
        setFontBackColor("");

        // document.querySelectorAll('.select_box_text_editor').forEach((element) => {
        //     element.value = "";
        // });
        document.querySelectorAll('.txt_font_family_text_editor').forEach((element) => {
            element.innerHTML = "글씨체";
        });
        document.querySelectorAll('.txt_font_size_text_editor').forEach((element) => {
            element.innerHTML = "글씨 크기";
        });

        document.querySelectorAll(".icon_text_editor").forEach((element) => {
            element.style.backgroundColor = "#FFF";
        });

    }, [
        onBannerTemplateChange,
        onMobileBannerTemplateChange,
        isHorizontal,
        w_large_text_color,
        h_large_text_color,
        w_small_text_color,
        h_small_text_color,
    ]);

    // 초기화 버튼 클릭
    const removeFormatHandler = (e, id) => {
        if(checkSelection()){
            return;
        }
        if (document.getSelection().anchorNode.parentElement.closest("." + id)) {
            document.execCommand('removeFormat', false, null);
            document.execCommand('backColor', false, "initial");

            // 셀렉트박스 초기화
            // document.querySelectorAll("#" + id + ' .select_box_text_editor').forEach((element) => {
            //     element.value = "";
            // });
            document.querySelectorAll('.txt_font_family_text_editor').forEach((element) => {
                element.innerHTML = "글씨체";
            });
            document.querySelectorAll('.txt_font_size_text_editor').forEach((element) => {
                element.innerHTML = "글씨 크기";
            });

            // 컬러 초기화
            setFontColor("");
            setFontBackColor("");
        }
    }

    // selection 정보 저장
    const saveSelection = () => {
        const selection = window.getSelection();
        if (selection && selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            range && setSelectedRange(range);
        }
    }

    // selection 복구
    const recoverSelection = () => {
        if(document.getSelection().type === 'None'){
            return;
        }
        if(selectedRange){
            const selection = document.getSelection();
            const range = document.createRange();
            range.setStart(selectedRange.startContainer, selectedRange.startOffset);
            range.setEnd(selectedRange.endContainer, selectedRange.endOffset);
            const isBlockSelected = range.startContainer !== range.endContainer || range.startOffset !== range.endOffset;
            if (isBlockSelected) {
                selection.removeAllRanges();
                selection.addRange(range);
            }
        }
    }

    // selection 복구
    useEffect(() => {
        if (!/iPad|iPhone|iPod/.test(navigator.platform)) {
            // recoverSelection();
        }
    }, [selectedRange]);

    // 폰트체 선택
    const handleSelectBoxFontFamilyOnChange = (e, editor) => {
        if(checkSelection()){
            return;
        }
        if (document.getSelection().anchorNode.parentElement.closest(".text_editor_title").className.includes(editor)) {
            document.execCommand("fontName", false, e.target.value);
        }
    }

    // 폰트 사이즈 선택
    const handleSelectBoxFontSizeOnChange = (e, editor) => {
        if(checkSelection()){
            return;
        }
        if (document.getSelection().anchorNode.parentElement.closest(".text_editor_title").className.includes(editor)) {
            switch (e.target.value) {
                case "0.8" :
                    document.execCommand("fontSize", false, "1");
                    break;
                case "1" :
                    document.execCommand("fontSize", false, "2");
                    break;
                case "1.2" :
                    document.execCommand("fontSize", false, "3");
                    break;
                case "1.4" :
                    document.execCommand("fontSize", false, "4");
                    break;
                case "1.6" :
                    document.execCommand("fontSize", false, "5");
                    break;
                case "1.8" :
                    document.execCommand("fontSize", false, "6");
                    break;
                case "2" :
                    document.execCommand("fontSize", false, "7");
                    break;
            }
        }
    }

    // 폰트 자간 선택
    const handleSelectBoxLetterSpacingOnChange = (e, editor) => {
        if(selectedRange && selectedRange.startContainer.parentElement.closest("." + editor)){
            // recoverSelection();
            // execHandler('letter-spacing', e.target.value, 'em');
        }
    }

    // 폰트 행간 선택
    const handleSelectBoxLineHeightOnChange = (e, editor) => {
        if(selectedRange && selectedRange.startContainer.parentElement.closest("." + editor)){
            // recoverSelection();
            // execHandler('line-height', e.target.value, 'em');
        }
    }

    // 폰트 색상 팔레트 열고 닫기
    const handleFontColorClick = (e, id) => {
        recoverSelection();
        setFontColorSketchPickerIsOpen((prev) => !prev);
    }

    // 폰트 배경 색상 팔레트 열고 닫기
    const handleFontBackColorClick = (e, id) => {
        recoverSelection();
        setFontBackColorSketchPickerIsOpen((prev) => !prev);
    };

    useEffect(() => {
        if(fontColorSketchPickerIsOpen){
            document.querySelector("#" + id + " .font_color_sketchpicker").style.display = "block";
            document.querySelector("#" + id + " .icon_font_color_text_editor").classList.replace("icn_four_ractangle", "icn_four_ractangle_on");
            setPaletteBackIsOpen(true);
        }

        document.addEventListener("mousedown", (e) => {
            if (e.target.closest(".wrap_font_color_text_editor")) {
                closePaletteHandler();
                setPaletteBackIsOpen(false);
                return;
            }
            if(fontColorSketchPickerIsOpen){
                closePaletteHandler();
                setFontColorSketchPickerIsOpen(false);
                setPaletteBackIsOpen(false);
            }
        });
    }, [fontColorSketchPickerIsOpen]);


    useEffect(() => {
        if(fontBackColorSketchPickerIsOpen){
            document.querySelector("#" + id + " .font_back_color_sketchpicker").style.display = "block";
            document.querySelector("#" + id + " .icon_font_back_color_text_editor").classList.replace("icn_four_ractangle", "icn_four_ractangle_on");
            setPaletteBackIsOpen(true);
        }

         if (document.querySelector("#palleteBack") != null) {
            document.querySelector("#palleteBack").onclick = ((e) => {
                closePaletteHandler();
                setFontBackColorSketchPickerIsOpen(false);
                setPaletteBackIsOpen(false);
            });
        }
    }, [fontBackColorSketchPickerIsOpen]);

    useEffect(() => {
        if(paletteBackIsOpen){
            if (document.querySelector("#palleteBack") != null) { document.querySelector("#palleteBack").style.display = "block"; }
        }else{
            if (document.querySelector("#palleteBack") != null) { document.querySelector("#palleteBack").style.display = "none"; }
        }
    }, [paletteBackIsOpen]);

    // 색상 팔레트 닫기
    const closePaletteHandler = () => {
        document.querySelectorAll(".sketch-picker").forEach((element) => {
            element.style.display = "none";
        });
        document.querySelectorAll(".icon_font_color_text_editor").forEach((element) => {
            element.classList.replace("icn_four_ractangle_on", "icn_four_ractangle");
        });
        document.querySelectorAll(".icon_font_back_color_text_editor").forEach((element) => {
            element.classList.replace("icn_four_ractangle_on", "icn_four_ractangle");
        });
    };

    // const handleChangeFontColor = (color, editor, complete) => {
    //     setFontColor(color.hex);
    //     try{
    //         if(checkSelection()){
    //             return;
    //         }
    //         if (document.getSelection().anchorNode.parentElement.closest(".text_editor_title").className.includes(editor)) {
    //             document.execCommand("foreColor", false, color.hex);
    //         }
    //     }catch (e) {
    //         console.log(e);
    //     }
    // };

    const handleChangeFontColor = (color, editor) => {
        // 1. 상태 업데이트를 먼저 호출 (필요한 경우)
        setFontColor(color.hex);

        // 2. 브라우저가 리렌더링 처리를 마친 후 실행되도록 지연
        setTimeout(() => {
            try {
                const selection = document.getSelection();
                // id로 직접 가져오는 것이 가장 정확합니다 (ContentEditable에 id="title"이 있으므로)
                const editorEl = document.getElementById(contentEditableId); 

                if (!editorEl) return;

                editorEl.focus(); // 포커스 강제 부여

                if (selection.isCollapsed) {
                    // 선택 영역이 없을 때 전체 선택 로직
                    const range = document.createRange();
                    range.selectNodeContents(editorEl); 
                    selection.removeAllRanges();
                    selection.addRange(range);

                    // 색상 적용
                    document.execCommand("foreColor", false, color.hex);

                    // 적용 후 선택 영역 해제 (커서를 끝으로)
                    selection.collapseToEnd();
                } else {
                    // 드래그 영역이 이미 있는 경우
                    document.execCommand("foreColor", false, color.hex);
                }
            } catch (e) {
                console.error(e);
            }
        }, 0); // 0ms지만 이벤트 루프의 다음 차례로 미뤄서 렌더링 충돌을 피함
    };

    // const handleChangeFontBackColor = (color, editor, complete) => {
    //     setFontBackColor(color.hex);
    //     try{
    //         if(checkSelection()){
    //             return;
    //         }
    //         if (document.getSelection().anchorNode.parentElement.closest(".text_editor_title").className.includes(editor)) {
    //             document.execCommand("backColor", false, color.hex);
    //         }
    //     }catch (e) {
    //         console.log(e);
    //     }
    // };

    const handleChangeFontBackColor = (color, editor) => {
        // 1. 배경색 상태 업데이트
        setFontBackColor(color.hex);

        // 2. React 렌더링 사이클을 피하기 위해 setTimeout 사용
        setTimeout(() => {
            try {
                const selection = document.getSelection();
                if (!selection) return;

                // id="title"을 사용하여 정확한 에디터 엘리먼트 타겟팅
                const editorEl = document.getElementById(contentEditableId);
                if (!editorEl || !editorEl.classList.contains(editor)) return;

                editorEl.focus();

                if (selection.isCollapsed) {
                    // [선택 영역이 없는 경우] 전체 선택 후 배경색 적용
                    const range = document.createRange();
                    range.selectNodeContents(editorEl);
                    selection.removeAllRanges();
                    selection.addRange(range);

                    document.execCommand("backColor", false, color.hex);

                    // 적용 후 선택 해제 및 커서를 끝으로 이동
                    selection.collapseToEnd();
                } else {
                    // [선택 영역이 있는 경우] 드래그한 부분만 적용
                    document.execCommand("backColor", false, color.hex);
                }
            } catch (e) {
                console.error("Font background color error:", e);
            }
        }, 0);
    };

    // const onEmojiClick = (emojiData) => {
    //     console.log(emojiData)
    //     setSelectedEmoji(emojiData.unified);
    // }

    const handleEmojiToggleOnClick = () => {
        setEmojiPickerIsOpen((prev) => !prev);
    };
   
    const handleTranslateToggleOnClick = () => {
        setTranslatePickerIsOpen((prev) => !prev);
    };

    useEffect(() => {
        if(emojiPickerIsOpen){
            document.querySelector("#" + id + " em-emoji-picker").style.display = "flex";
            setPaletteBackIsOpen(true);
        }else{
            document.querySelector("#" + id + " em-emoji-picker").style.display = "none";
        }

        if (document.querySelector("#palleteBack") != null) {
            document.querySelector("#palleteBack").onclick = (e) => {
                document.querySelectorAll("em-emoji-picker").forEach((element) => {
                    element.style.display = "none";
                });
                setEmojiPickerIsOpen(false);
                setPaletteBackIsOpen(false);
            }
        }
    }, [emojiPickerIsOpen]);

    const handleEmojiSelect = (emoji, id) => {
        try{
            if(selectedRange){
                if(selectedRange.startContainer.parentElement.closest("." + id)){
                    if(document.getSelection().type === 'Range'){
                        execEmoji(emoji);

                    }else {
                        focusInTextarea(id);
                        insertEmoji(emoji);
                        recoverSelection();
                        execEmoji(emoji);
                    }
                } else {
                    focusInTextarea(id);
                    insertEmoji(emoji);
                    recoverSelection();
                    execEmoji(emoji);
                }
            }else{
                focusInTextarea(id);
                const spanNode = document.createElement('span');
                spanNode.innerHTML = emoji.native;
                document.getSelection().getRangeAt(0).insertNode(spanNode);
                recoverSelection();
                execEmoji(emoji);
            }
        }catch (e) {
            console.log(e);
        }
        setEmojiPickerIsOpen(false);
        setPaletteBackIsOpen(false);
    }

    const insertEmoji = (emoji) => {
        const spanNode = document.createElement('span');
        spanNode.innerHTML = emoji.native;
        selectedRange.insertNode(spanNode);
    }

    const execEmoji = (emoji) => {
        const spanString = $('<span/>', {
            'text': emoji.native
        }).prop('outerHTML');

        document.execCommand('insertHTML', false, spanString);
    }

    const focusInTextarea = (id) => {
        const newRange = document.createRange();

        if(document.querySelector("." + id).lastChild){
            newRange.setStart(document.querySelector("." + id).lastChild, 0);
            newRange.setEnd(document.querySelector("." + id).lastChild, 0);
        }else{
            newRange.setStart(document.querySelector("." + id), 0);
            newRange.setEnd(document.querySelector("." + id), 0);
        }
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(newRange);
    }

    useEffect(() => {
        document.onclick = (e) => {chooseTextEditor(e)};
    });

    const chooseTextEditor = (e) => {
        if(e.target.closest("#mainTextEditor") || e.target.closest(".mainTextEditor")){
            iconBackgroundToggleHandler(e, "mainTextEditor");
        }else if(e.target.closest("#subTextEditor") || e.target.closest(".subTextEditor")){
            iconBackgroundToggleHandler(e, "subTextEditor");
        }
    }

    const iconBackgroundToggleHandler = (e, editor) => {
        changeIconBackgroundHandler(editor, "b", "bold");
        changeIconBackgroundHandler(editor, "i", "italic");
        changeIconBackgroundHandler(editor, "u", "underline");
        changeIconBackgroundHandler(editor, "strike", "strikeThrough");
        changeIconBackgroundHandler(editor, "ul", "insertUnorderedList");
        changeIconBackgroundHandler(editor, "ol", "insertOrderedList");
    }

    // 텍스트 에디터 아이콘 눌림 표시
    const changeIconBackgroundHandler = (editor, tag, tagName) => {
        if(checkSelection()){
            return;
        }
        if (document.getSelection().anchorNode.parentElement.closest(".text_editor_title").className.includes(editor)) {
            if (document.getSelection().anchorNode.parentElement.closest(tag) || document.getSelection().focusNode.parentElement.closest(tag)) {
                document.querySelectorAll("#" + editor + " ."+tagName).forEach((element) => {
                    element.style.backgroundColor = "#E3E3E3";
                    element.style.borderRadius = "6px";
                });
            } else {
                document.querySelectorAll("#" + editor + " ."+tagName).forEach((element) => {
                    element.style.backgroundColor = "#FFF";
                });
            }
        }
    }

    const handleInsertImageOnClick = () => {
        setImgAttachIsOpen((prev) => !prev);
    }

    useEffect(() => {
        if(imgAttachIsOpen){
            document.querySelector("#" + id + " .img_attach_editor").style.display = "block";
            setImgAttachIsOpen(true);
            setPaletteBackIsOpen(true);
        }else{
            document.querySelector("#" + id + " .img_attach_editor").style.display = "none";
            setImgAttachIsOpen(false);
            setPaletteBackIsOpen(false);
        }

        if (document.querySelector("#palleteBack") != null) {
            document.querySelector("#palleteBack").onclick = (e) => {
                document.querySelector("#" + id + " .img_attach_editor").style.display = "none";
                setImgAttachIsOpen(false);
                setPaletteBackIsOpen(false);
            }
        }
    }, [imgAttachIsOpen]);

    const checkFileExtension = (file) => {
        let reg = /(.*?)\.(jpg|jpeg|png|gif|bmp)$/i;

        if(String(file[0].name).match(reg)) {
            return true;
        }else{
            return false;
        }
    }

    const handleImgUploadOnChange = useCallback((e) => {
        if (!e.target.files) {
            return;
        }

        if(!checkFileExtension(e.target.files)){
            alert("이미지 파일만 첨부할 수 있습니다.");
            return;
        }

        const formData = new FormData();
        formData.append('files', e.target.files[0]);

        axios({
            url: '/rest/shop/roboBanner/save/orgImg',
            method: 'POST',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
            .then(response => {
                let img_path = response.data.org_img_path_uri_encode;
                insertImg(img_path);
                setImgAttachIsOpen(false);
            })
            .catch(error => {
                console.error(error);
            });

        e.target.value = '';

    }, []);

    const insertImg = (img_path) => {
        focusInTextarea(id);
        const imgString = '<img class="img_in_text_editor" src="' + img_path + '"/>';
        document.execCommand('insertHTML', false, imgString);
        focusInTextarea(id);
    }

    const handleImgUploadOnClick = useCallback(() => {
        if (!inputRef.current) {
            return;
        }
        inputRef.current.click();
    }, []);

    const handleEnterImgUrlOnClick = () => {
        setImgUrlDialogIsOpen((prev) => !prev);
    }

    useEffect(() => {
        if(imgUrlDialogIsOpen){
            document.querySelector("#" + id + " .img_attach_editor").style.display = "none";
            windowScrollTop = StyleUtil.onPopupNoneScroll(windowScrollTop);
        }else{
            document.querySelector("#" + id + " .img_attach_editor").style.display = "none";
            StyleUtil.clearPopupNoneScroll(windowScrollTop);
        }
    }, [imgUrlDialogIsOpen]);

    const handleSelectListFontFamilyToggle = () => {
        recoverSelection();
        setFontFamilyIsOpen((prev) => !prev)
    }

    useEffect(() => {
        if(fontFamilyIsOpen){
            if(document.querySelector("#" + id + " .select_list_font_family")){
                document.querySelector("#" + id + " .select_list_font_family").style.display = "block";
                document.querySelector("#" + id + " .select_list_font_family").style.top = "42px";
            }else if(document.querySelector("#" + id + " .select_list_font_family_mobile")) {
                document.querySelector("#" + id + " .select_list_font_family_mobile").style.display = "block";
                document.querySelector("#" + id + " .select_list_font_family_mobile").style.top = "30vh";
                windowScrollTop = StyleUtil.onPopupNoneScroll(windowScrollTop);

                if(document.getSelection().type === 'Range') {
                    hideKeyboard(id);
                }
            }
            setFontFamilyIsOpen(true);
            setPaletteBackIsOpen(true);

        }else {
            closeSelectListFontFamily(id);
        }

        if (document.querySelector("#palleteBack") != null) {
            document.querySelector("#palleteBack").onclick = (e) => {
                closeSelectListFontFamily(id);
            }
        }

    }, [fontFamilyIsOpen]);

    const closeSelectListFontFamily = (id) => {
        if(document.querySelector("#" + id + " .select_list_font_family")){
            document.querySelector("#" + id + " .select_list_font_family").style.display = "none";
        }else if(document.querySelector("#" + id + " .select_list_font_family_mobile")) {
            document.querySelector("#" + id + " .select_list_font_family_mobile").style.top = "1000vh";
            StyleUtil.clearPopupNoneScroll(windowScrollTop);
        }
        setFontFamilyIsOpen(false);
        setPaletteBackIsOpen(false);
    }

    const handleSelectListFontFamilyOnClick = (e, editor, fontName, fontValue) => {
        recoverSelection();
        document.execCommand("fontName", false, fontName);
        document.querySelector("#" + editor +" .txt_font_family_text_editor").innerHTML = fontValue;
    }

    const handleSelectListFontSizeToggle = () => {
        recoverSelection();
        setFontSizeIsOpen((prev) => !prev)
    }

    // useEffect(() => {
    //     if(fontSizeIsOpen){
    //         if(document.querySelector("#" + id + " .select_list_font_size")){
    //             document.querySelector("#" + id + " .select_list_font_size").style.display = "block";
    //             document.querySelector("#" + id + " .select_list_font_size").style.top = "42px";
    //         }else if(document.querySelector("#" + id + " .select_list_font_size_mobile")) {
    //             document.querySelector("#" + id + " .select_list_font_size_mobile").style.display = "block";
    //             document.querySelector("#" + id + " .select_list_font_size_mobile").style.top = "60vh";
    //             windowScrollTop = StyleUtil.onPopupNoneScroll(windowScrollTop);
    //
    //             if(document.getSelection().type === 'Range') {
    //                 hideKeyboard(id);
    //             }
    //         }
    //         setFontSizeIsOpen(true);
    //         setPaletteBackIsOpen(true);
    //
    //     }else {
    //         closeSelectListFontSize(id);
    //     }
    //
    //     document.querySelector("#palleteBack").onclick = (e) => {
    //         closeSelectListFontSize(id);
    //     }
    //
    // }, [fontSizeIsOpen]);

    const closeSelectListFontSize = (id) => {
        if(document.querySelector("#" + id + " .select_list_font_size")){
            document.querySelector("#" + id + " .select_list_font_size").style.display = "none";
        }else if(document.querySelector("#" + id + " .select_list_font_size_mobile")) {
            document.querySelector("#" + id + " .select_list_font_size_mobile").style.top = "1000vh";
            StyleUtil.clearPopupNoneScroll(windowScrollTop);
        }
        setFontSizeIsOpen(false);
        setPaletteBackIsOpen(false);
    }

    const handleSelectListFontSizeOnClick = (e, editor, value) => {
        recoverSelection();
        switch (value) {
            case 0.8 :
                document.execCommand("fontSize", false, "1");
                break;
            case 1 :
                document.execCommand("fontSize", false, "2");
                break;
            case 1.2 :
                document.execCommand("fontSize", false, "3");
                break;
            case 1.4 :
                document.execCommand("fontSize", false, "4");
                break;
            case 1.6 :
                document.execCommand("fontSize", false, "5");
                break;
            case 1.8 :
                document.execCommand("fontSize", false, "6");
                break;
            case 2 :
                document.execCommand("fontSize", false, "7");
                break;
        }
        document.querySelector("#" + editor +" .txt_font_size_text_editor").innerHTML = value + "x";
    }

    const hideKeyboard = (id) => {
        setTimeout(function () {
            document.querySelector("#" + id + " .hide_mobile_keybord").style.display = "block";
            document.querySelector("#" + id + " .hide_mobile_keybord").focus();
            setTimeout(function () {
                document.querySelector("#" + id + " .hide_mobile_keybord").style.display = "none";
            }, 10);
        }, 10);
    }

    const line = <div className={"line_text_editor"}>{textEditorIcon.line}</div>;

    return (
        <div id={id} className={"container_text_editor"}>
            <style>{`
                #${id} .font_family_text_editor {
                    width: 100% !important;
                    max-width: none !important;
                    flex: 0 0 100%;
                    box-sizing: border-box;
                    margin-left: 0 !important;
                    margin-right: 0 !important;
                }

                #${id} .txt_font_family_text_editor {
                    flex: 1;
                    min-width: 0;
                }
                
                #${id} .font_family_wrap_text_editor .bg_text_editor {
                    height: auto !important;
                }
            `}</style>
            {/* fontColor : {fontColor} <br/> */}
            <input type="text" className={"hide_mobile_keybord"} style={{display: "none"}}/>
            <div className={"wrap_text_editor"}>
                <div className={"font_family_wrap_text_editor"} style={{display: "flex", flexWrap: "wrap", width: "100%", alignItems: "center", gap: "5px"}}>
                    <div className={"font_family_text_editor"} onClick={handleSelectListFontFamilyToggle} style={{flex: 1}}>
                            {/*<SelectBox className={"select_box_font_family"} options={textEditorFont} onChange={(e) => {handleSelectBoxFontFamilyOnChange(e, id)}} defaultValue={"글씨체"} />*/}
                            <div className={"txt_font_family_text_editor"}>글씨체</div>
                            {/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ?
                                <div className={"select_list_text_editor_mobile select_list_font_family_mobile"}>
                                    <ul>
                                        <button className={"btn_close_select_list"} onClick={() => {closeSelectListFontFamily(id);handleSelectListFontFamilyToggle();}}>
                                            {textEditorIcon.arrowDownBold}
                                        </button>
                                        {textEditorFont.map((obj) => (
                                            <li style={{fontFamily: obj.name}} onClick={(e) => handleSelectListFontFamilyOnClick(e, id, obj.name, obj.value)}>{obj.value}</li>
                                        ))}
                                    </ul>
                                </div>
                                :
                                <div className={"select_list_text_editor select_list_font_family"}>
                                    <ul>
                                        {textEditorFont.map((obj) => (
                                            <li style={{fontFamily: obj.name}} onClick={(e) => handleSelectListFontFamilyOnClick(e, id, obj.name, obj.value)}>{obj.value}</li>
                                        ))}
                                    </ul>
                                </div>
                            }
                            <div className={"select_box_arrow"}>
                                {textEditorIcon.arrowDown}
                            </div>
                        </div>

                    <div className={"bg_text_editor"} style={{margin:0}}>
                        <Icon editor={id} icon={textEditorIcon.bold} tagName={tagName.bold} tag={"b"} />
                        <Icon editor={id} icon={textEditorIcon.underline} tagName={tagName.underline} tag={"u"} />
                        <Icon editor={id} icon={textEditorIcon.strikeThrough} tagName={tagName.strikeThrough} tag={"strike"} />
                    </div>    
                </div>    
                {/*{line}*/}
                {/*<div className={"font_size_text_editor"} onClick={handleSelectListFontSizeToggle}>*/}
                {/*    /!*<SelectBox className={"select_box_font_size"} options={textEditorFontSize} onChange={(e) => {handleSelectBoxFontSizeOnChange(e, id)}} defaultValue={"글씨 크기"} />*!/*/}
                {/*    <div className={"txt_font_size_text_editor"}>글씨 크기</div>*/}
                {/*    {/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ?*/}
                {/*        <div className={"select_list_text_editor_mobile select_list_font_size_mobile"}>*/}
                {/*            <ul>*/}
                {/*                <button className={"btn_close_select_list"} onClick={() => {closeSelectListFontSize(id);handleSelectListFontSizeToggle();}}>*/}
                {/*                    {textEditorIcon.arrowDownBold}*/}
                {/*                </button>*/}
                {/*                {textEditorFontSize.map((obj) => (*/}
                {/*                    <li onClick={(e) => handleSelectListFontSizeOnClick(e, id, obj.value)}>{obj.value}x</li>*/}
                {/*                ))}*/}
                {/*            </ul>*/}
                {/*        </div>*/}
                {/*        :*/}
                {/*        <div className={"select_list_text_editor select_list_font_size"}>*/}
                {/*            <ul>*/}
                {/*                {textEditorFontSize.map((obj) => (*/}
                {/*                    <li onClick={(e) => handleSelectListFontSizeOnClick(e, id, obj.value)}>{obj.value}x</li>*/}
                {/*                ))}*/}
                {/*            </ul>*/}
                {/*        </div>*/}
                {/*    }*/}
                {/*    <div className={"select_box_arrow"}>*/}
                {/*        {textEditorIcon.arrowDown}*/}
                {/*    </div>*/}
                {/*</div>*/}
                {line}
                {/* <div className={"bg_text_editor"}>
                    <Icon editor={id} icon={textEditorIcon.bold} tagName={tagName.bold} tag={"b"} />
                    <Icon editor={id} icon={textEditorIcon.underline} tagName={tagName.underline} tag={"u"} />
                    <Icon editor={id} icon={textEditorIcon.strikeThrough} tagName={tagName.strikeThrough} tag={"strike"} />
                </div> */}
                {/* {line} */}
                {/* <div className={"bg_text_editor"}>
                    <Icon editor={id} icon={textEditorIcon.insertUnorderedList} tagName={tagName.insertUnorderedList} tag={"ul"} />
                    <Icon editor={id} icon={textEditorIcon.insertOrderedList} tagName={tagName.insertOrderedList} tag={"ol"} />
                </div> */}
                {/*{line}*/}
                {/*<div className={"bg_text_editor bg_select_box"}>*/}
                {/*    <Icon editor={id} icon={textEditorIcon.letterSpacing} tagName={tagName.letterSpacing} />*/}
                {/*    <SelectBox className={"select_box_letter_spacing"} options={textEditorLetterSpacing} onChange={(e) => handleSelectBoxLetterSpacingOnChange(e, id)} />*/}
                {/*</div>*/}
                {/*{line}*/}
                {/*<div className={"bg_text_editor bg_select_box"}>*/}
                {/*    <Icon editor={id} icon={textEditorIcon.lineHeight} tagName={tagName.lineHeight} />*/}
                {/*    <SelectBox options={textEditorLineHeight} className={"select_box_line_height"} onChange={(e) => handleSelectBoxLineHeightOnChange(e, id)} />*/}
                {/*</div>*/}
                
                {/* {line} */}
                
                <div className={"bg_text_editor"}>
                    <div className={"img_text_editor"} title="이미지 삽입">
                        <div className={"icon_text_editor insertImage"} onClick={(e) => handleInsertImageOnClick(e, id)}>
                            {textEditorIcon.insertImage}
                        </div>
                        <div className={"wrap_img_attach_editor"}>
                            <div className={"img_attach_editor"}>
                                <input type="file" accept="image/*" ref={inputRef} onChange={handleImgUploadOnChange} style={{display: "none"}}/>
                                <div className={"img_upload_editor"} onClick={handleImgUploadOnClick}>이미지 파일 업로드</div>
                                <div className={"enter_img_url_editor"} onClick={handleEnterImgUrlOnClick}>이미지 URL 입력</div>
                            </div>
                        </div>
                    </div>
                    <div className={"wrap_translate_text_editor"}>
                        <div className={"translate_text_editor icon_text_editor"} title="문장 번역">
                            <div className={"translate_picker"} onClick={handleTranslateToggleOnClick} style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                                {/* 🌐 */}
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M22.9203 20.6644L17.6703 10.1644C17.608 10.0398 17.5123 9.93506 17.3938 9.86185C17.2753 9.78864 17.1388 9.74986 16.9995 9.74986C16.8603 9.74986 16.7237 9.78864 16.6053 9.86185C16.4868 9.93506 16.391 10.0398 16.3287 10.1644L14.2934 14.2359C12.6981 14.1462 11.1631 13.5952 9.875 12.6497C11.3863 11.0357 12.302 8.95463 12.4709 6.75H14.75C14.9489 6.75 15.1397 6.67098 15.2803 6.53033C15.421 6.38968 15.5 6.19891 15.5 6C15.5 5.80109 15.421 5.61032 15.2803 5.46967C15.1397 5.32902 14.9489 5.25 14.75 5.25H9.5V3.75C9.5 3.55109 9.42098 3.36032 9.28033 3.21967C9.13968 3.07902 8.94891 3 8.75 3C8.55109 3 8.36032 3.07902 8.21967 3.21967C8.07902 3.36032 8 3.55109 8 3.75V5.25H2.75C2.55109 5.25 2.36032 5.32902 2.21967 5.46967C2.07902 5.61032 2 5.80109 2 6C2 6.19891 2.07902 6.38968 2.21967 6.53033C2.36032 6.67098 2.55109 6.75 2.75 6.75H10.9653C10.7983 8.58811 10.018 10.3167 8.75 11.6578C7.95984 10.8241 7.35306 9.83406 6.96875 8.75156C6.93715 8.65712 6.88705 8.56991 6.82139 8.49503C6.75572 8.42015 6.6758 8.3591 6.58629 8.31544C6.49678 8.27178 6.39946 8.24639 6.30003 8.24074C6.2006 8.23509 6.10104 8.24931 6.00715 8.28255C5.91327 8.3158 5.82695 8.36741 5.75323 8.43437C5.67951 8.50133 5.61987 8.58231 5.57778 8.67257C5.53569 8.76283 5.51199 8.86057 5.50808 8.96009C5.50417 9.0596 5.52012 9.1589 5.555 9.25219C6.00244 10.5177 6.70726 11.6767 7.625 12.6562C6.21197 13.6946 4.50353 14.2531 2.75 14.25C2.55109 14.25 2.36032 14.329 2.21967 14.4697C2.07902 14.6103 2 14.8011 2 15C2 15.1989 2.07902 15.3897 2.21967 15.5303C2.36032 15.671 2.55109 15.75 2.75 15.75C4.92555 15.7524 7.03875 15.0234 8.75 13.68C10.1465 14.7711 11.8135 15.4617 13.5725 15.6778L11.0787 20.6644C10.9897 20.8423 10.975 21.0483 11.0379 21.237C11.1007 21.4257 11.236 21.5818 11.4139 21.6708C11.5918 21.7598 11.7978 21.7745 11.9865 21.7116C12.1753 21.6488 12.3313 21.5135 12.4203 21.3356L13.7131 18.75H20.2859L21.5788 21.3356C21.6411 21.4602 21.7369 21.565 21.8555 21.6382C21.9741 21.7114 22.1107 21.7501 22.25 21.75C22.3778 21.7499 22.5035 21.7172 22.6151 21.6549C22.7268 21.5926 22.8206 21.5028 22.8878 21.394C22.9549 21.2853 22.9932 21.1611 22.9989 21.0334C23.0046 20.9057 22.9775 20.7787 22.9203 20.6644ZM14.4631 17.25L17 12.1772L19.5359 17.25H14.4631Z" fill="#333333"/>
                                </svg>
                            </div>
                        </div>
                        <div className={"translate_language_picker_box"} style={{display: translatePickerIsOpen ? "block" : "none"}}>
                            <SelectBoxV2
                                id="language_select_box"
                                className="border_form_radius_b_h_42"
                                pageWrapperName="common-page-wrapper"

                                list={language_code_list ? language_code_list : []}
                                onlyValue={false}
                                optionTexttName="code_name"
                                optionValuetName="code_cd"

                                placeHolder="번역할 언어를 선택해주세요"
                                selectedValue={language_code}

                                onClickOption={(text, value) => {
                                    // (선택) 예전 <option language={val1}> 역할이 필요하면 여기서 val1도 같이 구할 수 있어요.
                                    const selectedObj = (language_code_list || []).find(
                                    (x) => x.code_cd === value
                                    );
                                    const language = selectedObj ? selectedObj.val1 : null; // 예전 option의 language 속성

                                    // 기존 onChange 핸들러가 event를 받는 구조라면, event 형태로 맞춰 호출
                                    // this.setState({ language_code: value }, () => {
                                    // if (typeof this.handleLanguageChange === "function") {
                                    //     this.handleLanguageChange({
                                    //     target: { value, language }, // 필요하면 language도 같이 전달
                                    //     });
                                    // }
                                    // });
                                    handleLanguageChange(id, value, language);
                                }}
                            />
                        </div>
                    </div>
                    <div className={"wrap_emoji_text_editor"}>
                        <div className={"emoji_text_editor"} title="이모지">
                            <div className={"emoji_picker"} onClick={handleEmojiToggleOnClick}>&#128578;</div>
                        </div>
                        <Picker data={data}
                                categories={["frequent", "people", "nature", "foods", "activity", "places", "objects", "symbols", "flags"]}
                                onEmojiSelect={emoji => handleEmojiSelect(emoji, id)}
                        />
                        {/*<EmojiPicker*/}
                        {/*    onEmojiClick={onEmojiClick}*/}
                        {/*    autoFocusSearch={false}*/}
                        {/*    theme={Theme.AUTO}*/}
                        {/*    emojiStyle={EmojiStyle.NATIVE}*/}
                        {/*/>*/}
                    </div>
                    <div className={"font_color_text_editor"}>
                        {/* <Icon editor={id} icon={textEditorIcon.foreColor} /> */}
                        <input className={"input_font_color_text_editor"} value={fontColor} placeholder={
                            id == "mainTextEditor" 
                                ? isHorizontal
                                    ? w_large_text_color 
                                    : h_large_text_color
                                : isHorizontal
                                    ? w_small_text_color 
                                    : h_small_text_color
                        } readOnly={true} disabled={true} />
                        <div className={"wrap_font_color_text_editor"} title="글자 색상">
                            <div className={"box_font_color_text_editor"} style={{backgroundColor:(
                                fontColor ? fontColor
                                    : id == "mainTextEditor" 
                                        ? isHorizontal
                                            ? w_large_text_color 
                                            : h_large_text_color
                                        : isHorizontal
                                            ? w_small_text_color 
                                            : h_small_text_color
                                ) }} onClick={(e) => handleFontColorClick(e, id)}>
                                <div className={"wrap_sketchpicker"} 
                                    onMouseDown={(e) => {
                                        e.preventDefault();   // 포커스 이동/selection 해제 방지
                                        e.stopPropagation();
                                }}>
                                    <SketchPicker
                                        className={"font_color_sketchpicker"}
                                        color={
                                            fontColor ? fontColor
                                                : id == "mainTextEditor" 
                                                    ? isHorizontal
                                                        ? w_large_text_color 
                                                        : h_large_text_color
                                                    : isHorizontal
                                                        ? w_small_text_color 
                                                        : h_small_text_color
                                        }
                                        onChange={(e) => handleChangeFontColor(e, id)}
                                        onChangeComplete={(e) => handleChangeFontColor(e, id, true)}
                                        disableAlpha
                                    />
                                </div>
                            </div>
                            <div className={"icon_font_color_text_editor icn_four_ractangle"} onClick={(e) => handleFontColorClick(e, id)}>
                                <div className={"wrap_sketchpicker"}
                                    onMouseDown={(e) => {
                                        e.preventDefault();   // 포커스 이동/selection 해제 방지
                                        e.stopPropagation();
                                }}>
                                    <SketchPicker
                                        className={"font_color_sketchpicker"}
                                        color={fontColor}
                                        onChange={(e) => handleChangeFontColor(e, id)}
                                        onChangeComplete={(e) => handleChangeFontColor(e, id, true)}
                                        disableAlpha
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"font_color_text_editor font_background_color_editor"}>
                        {/* <Icon editor={id} icon={textEditorIcon.backColor} /> */}
                        <input className={"input_font_back_color_text_editor"} value={fontBackColor} placeholder={"#FFFFFF"} readOnly={true} disabled={true} />
                        <div className={"wrap_font_color_text_editor"}>
                            <div className={"box_font_back_color_text_editor"} style={{backgroundColor:fontBackColor}} onClick={(e) => handleFontBackColorClick(e, id)}></div>
                            <div className={"icon_font_back_color_text_editor icn_four_ractangle"} onClick={(e) => handleFontBackColorClick(e, id)}>
                                <div className={"wrap_sketchpicker"}>
                                    <SketchPicker
                                        className={"font_back_color_sketchpicker"}
                                        color={fontBackColor}
                                        onChange={(e) => handleChangeFontBackColor(e, id)}
                                        onChangeComplete={(e) => handleChangeFontBackColor(e, id, true)}
                                        disableAlpha
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                {line}
                
                <div className={"flexBox"} style={{flexWrap: "nowrap"}}>
                    <div className={"bg_text_editor"} style={{marginRight: 0}}>
                        <Icon editor={id} icon={textEditorIcon.removeFormat} tagName={tagName.removeFormat} />
                        <button className={"txt_removeFormat"} onClick={(e) => removeFormatHandler(e, id)}>초기화</button>
                    </div>
                    <div className={"bg_text_editor"}>
                        <Icon editor={id} icon={textEditorIcon.undo} tagName={tagName.undo} />
                        <Icon editor={id} icon={textEditorIcon.redo} tagName={tagName.redo} />
                    </div>
                </div>

            </div>{/* ./end wrap_text_editor  */}

            {/* 에디터 하단 문구 */}
            {/*<p className={"notice_text_editor"}><i className={"fa fa-exclamation-circle"} aria-hidden="true"></i>&nbsp;글씨체에 따라 에디터 기능이 적용되지 않을 수 있어요.</p>*/}

            {/* 이미지 URL 입력 다이얼로그 */}
            {imgUrlDialogIsOpen &&
                <InputDialogV2
                    title={"이미지 URL 입력"}
                    input_value={""}
                    button_list={[
                        {
                            title: "확인",
                            type: "1",
                            event_method: (e) => {
                                if(e.target.value === ""){
                                    alert("이미지 URL 주소를 입력해주세요.");
                                } else{
                                    checkImgLinkUseAble(e.target.value ,function () {
                                        insertImg(e.target.value);
                                        setImgUrlDialogIsOpen(false);
                                        StyleUtil.clearPopupNoneScroll(windowScrollTop);

                                    }, function () {
                                        alert("올바른 URL 주소를 입력해주세요.");
                                    });
                                }
                            }
                        },
                        {
                            title: "취소",
                            type: "0",
                            event_method: (e) => {
                                setImgUrlDialogIsOpen(false);
                                StyleUtil.clearPopupNoneScroll(windowScrollTop);
                            }
                        }
                    ]}
                    popup_close={() => {
                        setImgUrlDialogIsOpen(false);
                        StyleUtil.clearPopupNoneScroll(windowScrollTop);
                    }}
                />
            }

        </div>// ./end container_text_editor
    );

}

// 블록 정보 초기화 (텍스트 문구 입력창 onMouseDown 이벤트에 추가)
export const initSelectionOnMouseDown = (e) => {
    e.stopPropagation();

    preClass = curClass
    curClass = e.target.className

    if (preClass != "" && preClass != curClass) {
        const selection = window.getSelection();
        selection.removeAllRanges();
        e.target.focus();
    }
}